
const popupEvents = new EventTarget();

/**
 * showPopup({ 
 *   type: 'success' | 'error' | 'warning' | 'info', 
 *   title: string, 
 *   message: string, 
 *   buttons: string[] | { label: string, onClick: () => void, variant?: 'primary' | 'danger' | 'ghost' }[],
 *   onConfirm?: () => void,
 *   onCancel?: () => void
 * })
 */
export const showPopup = (options) => {
    const event = new CustomEvent('show-popup', {
        detail: options
    });
    popupEvents.dispatchEvent(event);
};

export const subscribeToPopups = (callback) => {
    const handler = (event) => callback(event.detail);
    popupEvents.addEventListener('show-popup', handler);
    return () => popupEvents.removeEventListener('show-popup', handler);
};
